import isBrowser from '../isBrowser';

export default function setDocumentTitle(title: string): void {
  if (isBrowser) {
    document.title = title;
  }
}
